import React, { Component } from 'react'

class Settings extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      settings: [
        { name: 'Change password', key: 'changePassword' },
        {
          name: 'Set preferences',
          key: 'setPreferences',
        },
      ],
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, false)
  }

  handleClick = event => {
    if (!event.target.classList.contains('header__settings')) {
      this.props.toggleSettingsBox()
    }
  }

  renderSettingsList = () => {
    const { settings } = this.state
    return (
      <ul
        className="header__settings cw_panel cw_panel_notifications cw_panel_selected"
        id="cw_panel-notifications"
      >
        {settings.map((item, index) => {
          return (
            <li
              key={index}
              className="header__settings cw_notification pointer"
              onClick={() => this.props.toggleSettingsBox()}
            >
              <div className="header__settings flexCenter">
                <a>
                  <div className="header__settings cw_notification-header">
                    {item.name}
                  </div>
                </a>
              </div>
            </li>
          )
        })}
      </ul>
    )
  }

  render() {
    return (
      <div
        id="notifications-popover"
        className="header__settings cw_popover-container cw_notifications-container cw_popoverPrepToOpen cw_popoverIsOpening cw_popoverIsOpen"
        style={{ left: '-134px' }}
        aria-label="Popover Dialog"
      >
        <div className="header__settings cw_popover-body header__popover-body">
          {this.renderSettingsList()}
        </div>
      </div>
    )
  }
}

export default Settings
